import React from 'react';
import CardSecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import MainCard from '../../ui-component/cards/MainCard';
import { Button, filledInputClasses, Grid, Typography } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import { height } from '@mui/system';
import accessIMG from '../../assets/images/icons/denied.png';

const AccessDenied = () => {
  console.log("In Access Denied Function");
    return (
        <React.Fragment>
            <MainCard style={{ height: '80vh' }} title="" secondary={<CardSecondaryAction />}>
                {/* <Grid container spacing={gridSpacing}> */}
                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh'}}>
                    <img src={accessIMG} alt="Access Denied" 
                    style={{width: '30%', height: '30%', objectFit: 'contain'}}
                    />
                    <p style={{fontSize: '50px', fontWeight: '600'}}>Access Denied</p>
                </div>
                {/* </Grid> */}
            </MainCard>
        </React.Fragment>
    );
};

export default AccessDenied;
